import React from 'react';
import { ListingObjects } from 'hyperdb-utils';
import { HyperdbListing } from '../../../../hyperdb';

class Listing extends React.Component {
  constructor(props) {
    super(props);
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.submitSuccessful && nextProps.savedObject) {
      this.props.api.routing.redirect(this.props.router, `/content/areas/${nextProps.savedObject.id}`);
    }
  }
  render() {
    // TODO
    const clientId = JSON.parse(localStorage.getItem('currentUser')).client_id;
    const areaContents = (this.props.objects.area_contents || []).filter(area => {
      const barcelonaId = '18425409708756';
      return clientId === '3912abc1' || clientId === '12345678' ? area.zone.value[1] === barcelonaId : area.zone.value[1] !== barcelonaId;
    });
    return (
      <ListingObjects
        { ...this.props }
        objects={ { area_contents: areaContents } }
        deleteMessage="Are you sure you want to delete this content ?"
      />
    );
  }
}

export default HyperdbListing({
  CustomComponent: Listing,
  collectionName: 'area_contents',
  namespace: 'areaContent',
  mountedUrl: '/content/areas',
  title: 'Contents for areas',
  columns: [
    { attribute: 'name', label: 'area' },
    { label: 'defined', sortable: false, value: (object) => !!object.content.value[1] ? <i className="fas fa-check" /> : null },
    { attribute: 'node_uid', sortable: false },
  ],
  canCreate: false,
  canDelete: (object) => !!object.content.value[1],
  onEdit: (object, props) => {
    if (!object.content.value[1]) {
      const objectData = {
        id: 0,
        area: { $type: 'reference', external: true, value: ['areas', object.id] },
        website: {},
      };
      props.api.areaContent.submitCreateForm(objectData);
    } else {
      props.api.routing.redirect(props.router, `/content/areas/${object.content.value[1]}`);
    }
  },
  onDelete: (object, props) => {
    props.api.areaContent.deleteObject(object.content.value[1]);
  },
});



// WEBPACK FOOTER //
// ./src/frontend/modules/content/area-content/containers/Listing.jsx